/* storybook-check-ignore */
import { Button, Text } from '@opendoor/bricks/core';
import DiscountIcon from './icons/DiscountIcon';
import { css } from '@emotion/react';
import { useReducer } from 'react';
import Modal from './Modal';

export default function BackOutAnytimeInfo({
  isSellerOfferExperiment = true,
}: {
  isSellerOfferExperiment?: boolean;
}) {
  const [isModalOpen, toggleModalOpen] = useReducer((s) => !s, false);
  const info = isSellerOfferExperiment
    ? 'When you buy with Exclusives, you pay less. Since we represent the seller, we can use our commissions to pass savings back.'
    : 'We can save on traditional fees when we can sell a home directly to customers, those savings are reflected in the Exclusive Price.';
  return (
    <>
      <Button
        variant="link"
        analyticsName="cosmos-exclusives-back-out-any-time-info-button"
        aria-label={info}
        onClick={toggleModalOpen}
        display="flex"
        alignItems="center"
        gridGap="5px"
        fontSize="s0"
        fontWeight="semibold"
        color="brand50"
        lineHeight="s00"
        paddingX="0.25rem"
        css={css`
          border-radius: 5px;
          svg path {
            fill: #082de6 !important;
          }
          &:hover {
            opacity: 0.6;
            background-color: var(--colors-neutrals30);
          }
        `}
      >
        <DiscountIcon size={18} />
        Back out anytime
      </Button>
      <Modal title="Back out anytime" isOpen={isModalOpen} onRequestClose={toggleModalOpen}>
        <Text>{info}</Text>
      </Modal>
    </>
  );
}
